import React from "react";
import PropTypes from "prop-types";
import LinksCol from "./LinksCol";
import styles from "./footer.module.scss";

export const Col = LinksCol;

const LinksWidget = ({ title, children }) => {
  return (
    <div className={styles.linksWidet}>
      <div className={styles.title}>{title}</div>
      <div className={styles.links}>{children}</div>
    </div>
  );
};

LinksWidget.propTypes = {
  title: PropTypes.string,
  children(propValue, key) {
    const prop = propValue[key];

    let error = null;
    React.Children.forEach(prop, function (child) {
      if (child.type.name !== LinksCol.name) {
        error = new Error(
          "LinksWidget: All children should be of type LinksCol",
        );
      }
    });
    return error;
  },
};

LinksWidget.defaultProps = {
  title: "",
  children: [],
};

export default LinksWidget;
